import React, { useMemo } from 'react';
import { Page } from '../page/page';
import { VocabularyForm } from './vocabulary-form';
import environment from '../../lib/RelayUtils';
import { withRouter } from 'react-router-dom';
import { createFragmentContainer, graphql } from 'react-relay';
import { commit } from './mutations/vocabulary-edit';

export const VocabularyEdit = props => {
	const { history, viewer } = props;
	const { vocabularyItem } = viewer;

	const initialValues = useMemo(() => {
		return { ...vocabularyItem };
	}, [vocabularyItem]);

	const onSubmit = submitted => {
		if (!submitted.description) {
			submitted.description = '';
		}
		delete submitted.canDelete;
		commit(environment, submitted, (error: ?Error) => {
			if (error) {
				console.log();
			} else {
				history.push(`/vocabulary`);
			}
		});
	};

	return (
		<Page title="Справочник">
			<VocabularyForm initialValues={initialValues} onSubmit={onSubmit} />
		</Page>
	);
};

export default withRouter(
	createFragmentContainer(
		VocabularyEdit,
		graphql`
			fragment vocabularyEdit_viewer on Viewer @argumentDefinitions(id: { type: "ID!" }) {
				id
				vocabularyItem(id: $id) {
					...vocabularyListItem_item @relay(mask: false)
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/vocabulary/vocabulary-edit.js